'use client';

import { RecentSearches } from '@/components/Home/RecentSearches';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';

export function SearchHistoryModal({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/60 z-40" />
        <Dialog.Content className="fixed z-50 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gray-900 border border-[rgb(34,50,83)] rounded-2xl shadow-xl w-full max-w-xl p-0">
          <div className="flex justify-between items-center p-4 border-b border-gray-800">
            <span className="text-lg font-semibold text-white">Search History</span>
            <Dialog.Close asChild>
              <button className="rounded-full p-1 hover:bg-gray-800 text-gray-400 hover:text-white transition-colors">
                <X size={20} />
              </button>
            </Dialog.Close>
          </div>
          <div className="p-0">
            <RecentSearches />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
